import styled from 'styled-components';

export const SectionTitle = styled.h2`
  size: 24px;
  line-height: 24px;
  font-weight: 300;
  color: #1b1b1b;
  margin-bottom: 8px;
  font-family: 'halyard-text', sans-serif;
`;
